import React from 'react';
export const ProblemSection = () => {
  return <section className="mb-10" style={{
    backgroundColor: '#f8f7f4',
    borderLeft: '4px solid #76a0b4',
    padding: '1.5rem'
  }} data-id="element-123">
      <h2 className="text-4xl font-bold mb-4" style={{
      color: '#465866'
    }} data-id="element-124">
        What Vets Don't Tell You About Anxiety Medications
      </h2>
      <p className="text-xl mb-4 italic" data-id="element-125">
        "As a veterinarian, I have to be honest about what these medications
        actually do - and what we don't tell pet owners.
      </p>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-126">
        The Uncomfortable Truth About Dog Anxiety Meds:
      </h3>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-127">
        <li className="mb-1 font-bold" data-id="element-128">They Don't Actually "Cure" Anxiety</li>
        <li className="mb-1" data-id="element-129">They suppress symptoms, not the root cause</li>
        <li className="mb-1" data-id="element-130">Dogs often need them for life</li>
        <li className="mb-1" data-id="element-131">
          Anxiety frequently returns when medication stops
        </li>
      </ul>
      <div className="w-full h-[200px] bg-gray-200 mb-6 overflow-hidden" data-id="element-132">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5Cd1U8A28deDZp8B2EKFh3/anti-anxiety-medication-and-dogs.jpg" alt="Veterinarian giving medication to a dog" className="w-full h-full object-cover" data-id="element-133" />
      </div>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-134">
        The Side Effect Reality:
      </h3>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-135">
        <li className="mb-1" data-id="element-136">
          67% of dogs experience some form of side effect
        </li>
        <li className="mb-1" data-id="element-137">
          Lethargy and personality changes are considered 'normal'
        </li>
        <li className="mb-1" data-id="element-138">Some dogs become MORE anxious initially</li>
        <li className="mb-1" data-id="element-139">
          Digestive issues affect nearly half of all dogs on these meds
        </li>
      </ul>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-140">
        The Hidden Costs:
      </h3>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-141">
        <li className="mb-1" data-id="element-142">Annual bloodwork required ($200-400/year)</li>
        <li className="mb-1" data-id="element-143">Ongoing vet visits for monitoring</li>
        <li className="mb-1" data-id="element-144">Prescription costs add up quickly</li>
        <li className="mb-1" data-id="element-145">
          Emergency vet visits if dogs have adverse reactions
        </li>
      </ul>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-146">
        Why I Started Questioning Everything:
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-147">
        After Bailey's experience, I started really LOOKING at my patients on
        anxiety medication. What I saw disturbed me:
      </p>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-148">
        <li className="mb-1" data-id="element-149">
          Max, a Golden Retriever who stopped swimming (his passion) after
          starting Prozac
        </li>
        <li className="mb-1" data-id="element-150">
          Luna, a Border Collie whose intelligence seemed dulled by medication
        </li>
        <li className="mb-1" data-id="element-151">
          Cooper, a rescue who became so lethargic his family worried he was
          dying
        </li>
      </ul>
      <p className="text-xl mb-4 italic" data-id="element-152">
        These weren't 'medical failures' - these were the expected outcomes. We
        just called them 'acceptable side effects.'
      </p>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-153">
        The Question That Changed My Practice:
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-154">
        'What if there was a way to calm anxious dogs WITHOUT compromising who
        they are?'
      </p>
      <p className="text-xl mb-4 italic" data-id="element-155">
        That question led me to research that the pharmaceutical companies don't
        want you to know about..."
      </p>
    </section>;
};